import { useDocument } from "./useDocument";
import { useWindow } from "./useWindow";
const useScrollTo = () => {
    const myDocument = useDocument();
    const myWindow = useWindow();
    const scrollTo = (element) => {
        if (!myDocument && !myWindow) {
            return;
        }
        const { left, top } = element.getBoundingClientRect();
        const root = myDocument.documentElement;
        const headerHeightInPx = getComputedStyle(root).getPropertyValue("--header-height");
        const headerHeightNum = Number(headerHeightInPx.split("px")[0]);
        window.scrollTo(left, top + myWindow.scrollY - headerHeightNum);
    };
    return {
        scrollTo
    };
};
export default useScrollTo;
